import { useEffect } from "react";

/**
 * ============================================================================
 * ############## useBodyScrollLock：锁定 body 滚动 #############################
 * ============================================================================
 *
 * 【作用】（第三人称客观注释）
 * - 当移动端菜单/抽屉等覆盖层打开时，锁定 body 滚动，避免滚动穿透。
 * - 当覆盖层关闭或组件卸载时，恢复原始滚动状态。
 *
 * 【参数】（第三人称客观注释）
 * - locked: true 表示锁定；false 表示解除锁定。
 */
export const useBodyScrollLock = (locked: boolean) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    if (locked) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [locked]);
};
